<script>
  import { MainForm, Advantages, HowWeWork, Link, store } from '$client';
  export let data;
  const { city } = store;
  $: pricelist = data.pricelist;
  const href = (item, prefix) => (item.url ? prefix + item.url : item.href);
</script>

<section id="main" class="margin-top">
  <section class="container" id="price">
    <h1 class="h1">{pricelist.header}</h1>
    {#each pricelist.prices as list}
      <table itemscope itemtype="https://schema.org/OfferCatalog">
        <meta content={list.data.length} itemprop="numberOfItems" />
        <caption class="h2" itemprop="name">
          {#if list.url}
            <Link
              attributes={{ title: `${list.header} г. ${$city.header}`, itemprop: 'url', class: 'h2 color-button' }}
              href={'/' + href(list, 'kategoriya-')}></Link>
          {/if}
          {list.header} <br /> г. {$city.header}
        </caption>
        <thead>
          <tr>
            <th scope="col">Название услуги</th>
            <th scope="col">Стоимость (₽)</th>
          </tr>
        </thead>
        <tbody>
          {#each list.data as service}
            <tr itemprop="itemListElement" itemscope itemtype="https://schema.org/Offer">
              <td itemprop="name">
                {service.ancor ?? service.header}
                {#if service.url || service.href}
                  <Link
                    href={'/' + href(service, 'usluga-')}
                    attributes={{ title: service.ancor ?? service.header, itemprop: 'url', class: 'color-button' }}
                  ></Link>
                {/if}
              </td>
              <td>
                <link itemprop="availability" href="http://schema.org/InStock" />
                <div itemprop="areaServed" itemscope itemtype="https://schema.org/State">
                  <meta itemprop="name" content={$city.region} />
                </div>
                <div itemprop="aggregateRating" itemscope itemtype="https://schema.org/AggregateRating">
                  <meta itemprop="ratingValue" content="4.6" />
                  <meta itemprop="bestRating" content="5" />
                  <meta itemprop="ratingCount" content="45" />
                  <div itemprop="itemReviewed" itemscope itemtype="https://schema.org/ProfessionalService">
                    <meta itemprop="name" content="Вывоз ненужных вещей в г. {$city.header}" />
                    <meta itemprop="image" content="/favicon.svg" />
                    <meta itemprop="telephone" content={$city.phone} />
                    <meta itemprop="address" content={$city.office} />
                  </div>
                </div>
                <div itemprop="provider" itemscope itemtype="https://schema.org/LocalBusiness">
                  <meta itemprop="name" content="Убери" />
                  <meta itemprop="image" content="/favicon.svg" />
                  <meta itemprop="telephone" content={$city.phone} />
                  <meta itemprop="address" content={$city.office} />
                  <meta itemprop="priceRange" content="0₽-50000₽" />
                </div>
                {!service.price ? 'Бесплатно' : service.price}
                <meta itemprop="price" content={service.price} />
                <meta itemprop="priceCurrency" content="RUB" />
              </td>
            </tr>
          {/each}
        </tbody>
      </table>
    {/each}
  </section>
  <HowWeWork data={pricelist.howWeWork} />
  <section class="container advantages">
    <h2 class="h2">{pricelist.advantages.header}</h2>
    <Advantages data={pricelist.advantages.data} />
  </section>
  <MainForm data={pricelist.form.data.attributes} />
</section>

<style lang="scss">
  #main {
    display: flex;
    flex-direction: column;
    gap: 80px;

    @media only screen and (max-width: 767.98px) {
      gap: 50px;
    }
  }

  #price {
    gap: 55px;

    @media only screen and (max-width: 767.98px) {
      gap: 45px;
    }

    &,
    thead,
    tbody,
    table {
      display: flex;
      flex-direction: column;
      width: 100%;
    }

    caption {
      position: relative;
      margin-bottom: 50px;
      color: #2c333c;
      font-weight: 800;
      font-family: Vela Sans;
      font-style: normal;
      text-align: start;
      transition: color 0.1s;
      will-change: color;

      @media only screen and (max-width: 767.98px) {
        margin-bottom: 45px;
      }

      &:hover {
        color: #22eaac !important;
      }

      :global(a) {
        position: absolute;
        z-index: 2;
        width: 100%;
        height: 100%;
        color: rgb(44 51 60 / 100%);
      }
    }

    tr {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;

      th {
        color: #2c333c;
        font-weight: 500;
        font-size: 16px;
        font-family:
          Vela Sans,
          sans-serif;
        line-height: 22px;
      }
    }

    tbody tr {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin-top: 20px;
      padding-bottom: 20px;
      font-weight: bold;
      font-size: 20px;
      font-family:
        Vela Sans,
        sans-serif;
      line-height: 28px;
      border-bottom: 2px solid rgb(211 216 223 / 100%);

      @media only screen and (max-width: 1200px) {
        font-size: 17px;
      }

      @media only screen and (max-width: 575.98px) {
        font-size: 15px;
      }

      td {
        transition: color 0.1s;
        will-change: color;
      }

      &:hover > td {
        color: #22eaac !important;
      }

      :global(a) {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        width: 100%;
        height: 100%;
        color: rgb(44 51 60 / 100%);
      }
    }
  }

  h1 {
    color: #2c333c;
    font-weight: 800;
    font-family: Vela Sans;
    font-style: normal;
  }

  .advantages h2 {
    margin-bottom: 50px;
    color: #2c333c;
    font-weight: 800;
    font-family: Vela Sans;
  }
</style>
